module.exports = __webpack_public_path__ + "static/media/1.e9b638a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/1.png
// module id = 861
// module chunks = 0